import $ from "../libs/jquery-3.3.1.min.js"
import {BaseGame} from "/js/app/base/BaseGame";
// import {AudioPlaylist} from '/js/app/base/AudioPlaylist.js'
// import {gsap} from "../libs/gsap/all.js"
// import {Howl, Howler} from 'howler';
// import nunjucks from "/js/libs/nunjucks.js"

const {ipcRenderer} = inElectron() ? global.require('electron') : false;

// Constructor
export class VideotronPhone extends BaseGame {

  constructor() {

    // Super constructor
    super("data/gustav_videotron_phone.json"); // unneeded but let's keep it if we need to later on

    this.currentButtonState = false;
    this.currentSoundIndex = 0;
    this.availableSounds = [];

    // Wait for all
    Promise.all([
      this.loadSettings(),
      this.loadData()
    ]).then(() => {
      // Preload audio files
      return this.preloadAudio();
    }).then(() => {
      // Ini nunjucks
      return this.initNunjucks();
    }).then(() => {
      // Replace strings {{ }}
      return this.renderNunjucks();
    }).then(() => {
      // Real game init
      return this.initGame();
    }).catch((error) => {
      console.error("error", error)
      $("#main").append("<div id='error'>Error: " + error.message + "</div>")
    });
  }

  // To be overridden in child games
  initGame() {

    this.currentButtonState = this.settings.phone_docked_value;

    // store available sounds file names so we can play them easier later
    this.availableSounds = this.findAllAudioFiles(this.data);

    if (inElectron()) {
      // Listen for button state change and act accordingly
      ipcRenderer.on('button-state-change', (e, message) => {

        this.currentButtonState = message.state;
        // console.log(this.currentButtonState);

        // Make sure all sounds are stopped
        this.audio.clearAll();

        if (this.currentButtonState == this.settings.phone_undocked_value) {
          $("#main").addClass("sound-activated");
          this.playSound();
        } else {
          $("#main").removeClass("sound-activated");
        }
      });
    }


    // Let's also use the keyboard to trigger a button state change so we can debug easier
    $(window).keypress((e) => {
      if (e.key === ' ' || e.key === 'Spacebar') {
        // console.log("Trigger state change");
        this.currentButtonState = !this.currentButtonState;

        // Make sure all sounds are stopped
        this.audio.clearAll();

        if (this.currentButtonState == this.settings.phone_undocked_value) {
          $("#main").addClass("sound-activated");
          this.playSound();
        } else {
          $("#main").removeClass("sound-activated");
        }
      }
    })

    // super.initGame(); // We don't need the BaseGame in this case so let's skip it and handle things just here
  };

  playSound() {
    // Select the next sound
    let chosenSound = this.availableSounds[this.currentSoundIndex];
    let loop = true;

    // Play it
    this.audio.play(chosenSound, 1.0, true, false, false, loop);

    // increase sound index or start over
    this.currentSoundIndex = (this.currentSoundIndex + 1) % this.availableSounds.length;
  }

  reset(screenId) {

    // There is no real need to reset the app here as it's a single screen app in this case


    // if (this.currentTimeline) {
    //   this.currentTimeline.kill();
    //   this.currentTimeline = null;
    // }
    //
    // let resetCallback = () => {
    //   // TODO Add things to append after reset here, if required
    //
    //
    // }
    //
    // // TODO Reset other things here
    // this.animateScreen1();

    // Super
    if (super.reset(screenId, resetCallback) == false) {
      return false;
    }

  }

  randomInArray(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }
}
